"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const button_1 = __importDefault(require("components/cosmos/button/button"));
const modal_1 = require("components/cosmos/v2/modal");
const Html_1 = __importDefault(require("components/Html"));
const translationContext_1 = require("configs/translationContext");
const services_1 = require("modules/app/services");
const clickFreeModuleActivateSchema_1 = require("modules/app/services/datahubEvents/freeModule/clickFreeModuleActivateSchema");
const clickFreeModuleCancelSchema_1 = require("modules/app/services/datahubEvents/freeModule/clickFreeModuleCancelSchema");
const viewFreeModuleModalSchema_1 = require("modules/app/services/datahubEvents/freeModule/viewFreeModuleModalSchema");
const activate_free_signup_svg_1 = __importDefault(require("./assets/activate-free-signup.svg"));
const signUpModal_1 = require("./signUpModal");
const ActivateFreeSignup = ({ onNextStep, onClose }) => {
    const { t } = (0, translationContext_1.useTranslation)();
    (0, react_1.useEffect)(() => {
        const schema = new viewFreeModuleModalSchema_1.ViewFreeModuleModalSchema({
            step: signUpModal_1.ViewFreeModuleSteps.FREE_MODULE_ACTIVATE
        });
        services_1.DatahubEventsService.sendEvent({ schema });
    }, []);
    const handleCancel = () => {
        const schema = new clickFreeModuleCancelSchema_1.ClickFreeModuleCancelSchema();
        services_1.DatahubEventsService.sendEvent({ schema });
        onClose();
    };
    const handleActivate = () => {
        const schema = new clickFreeModuleActivateSchema_1.ClickFreeModuleActivationSchema();
        services_1.DatahubEventsService.sendEvent({ schema });
        onNextStep();
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(modal_1.Modal.Header, {}), (0, jsx_runtime_1.jsxs)(modal_1.Modal.Body, { className: "_d-flex _align-items-center _flex-column", children: [(0, jsx_runtime_1.jsx)("img", { src: activate_free_signup_svg_1.default, className: "", alt: "" }), (0, jsx_runtime_1.jsxs)("div", { className: "_text-center", children: [(0, jsx_runtime_1.jsx)("div", { className: "_text-4 _mt-4 _text-gray-900", children: t('module_editor.active_free_signup.step1.title') }), (0, jsx_runtime_1.jsx)("div", { className: "_text-2 _text-gray-500 _mt-4", children: (0, jsx_runtime_1.jsx)(Html_1.default, { children: t('module_editor.active_free_signup.step1.subtitle') }) })] }), (0, jsx_runtime_1.jsxs)("div", { className: "_d-flex _flex-column _mt-4 _w-full", children: [(0, jsx_runtime_1.jsx)(button_1.default, { variation: "primary", onClick: handleActivate, children: t('module_editor.active_free_signup.step1.activate') }), (0, jsx_runtime_1.jsx)(button_1.default, { variation: "custom", className: "_mt-2 _text-blue", onClick: handleCancel, children: t('module_editor.active_free_signup.step1.cancel') })] })] })] }));
};
exports.default = ActivateFreeSignup;
